<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button id="rto-btn-loading" color="danger" size="small" :textButton="$t('RTO')" :iconStyle="{iconPosition:'left', LeftIconName: 'undo', LeftIconLibrary: 'material'}" @click="confirmRTO()" class="vs-con-loading__container w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select only the orders you want to return to origin!')}`">
        <shipblu-button color="danger" size="small" :textButton="$t('RTO')" :iconStyle="{iconPosition:'left', LeftIconName: 'undo', LeftIconLibrary: 'material'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import common from '../../../assets/utils/common.js'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData.js'

export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false,
      rtoStatuses: ['picked_up', 'in_transit', 'en_route', 'out_for_delivery', 'delivery_attempted', 'reattempt_delivery']
    }
  },
  watch: {
    selected (val) {
      this.selectedFlag = val.length !== 0 && val.filter(item => this.rtoStatuses.includes(item.status) && !item.rto_requested).length !== 0
    }
  },
  methods: {
    confirmRTO () {
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to return these orders to origin?'],
        accept: this.rtoOrders
      })
    },
    rtoOrders () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#rto-btn-loading',
        scale: 0.45
      })
      const trackings = this.selected.filter(order => this.rtoStatuses.includes(order.status) && !order.rto_requested).map(order => ({
        order: order.id,
        packages: order.packages.map(item => item.package.id),
        status: 'return_to_origin'
      }))
      sendRequest(true, false, this, 'api/v1/tracking/', 'post', trackings, true,
        () => {
          this.$emit('loadShipments')
          this.$emit('selected', [])
          this.$vs.loading.close('#rto-btn-loading > .con-vs-loading')
        }, (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#rto-btn-loading > .con-vs-loading')
        }
      )
    }
  }
}
</script>
